/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComponenteNucleoMinDTO { 
    nome?: string;
    cognome?: string;
    parentela?: ComponenteNucleoMinDTOParentelaEnum;
}
export enum ComponenteNucleoMinDTOParentelaEnum {
    AFFIDATARIO = 'AFFIDATARIO',
    ALTRO = 'ALTRO',
    COGNATO = 'COGNATO',
    CONVIVENTE = 'CONVIVENTE',
    CURATORE = 'CURATORE',
    FIGLIO = 'FIGLIO',
    FIGLIA = 'FIGLIA',
    FRATELLO = 'FRATELLO',
    MADRE = 'MADRE',
    MARITO = 'MARITO',
    MOGLIE = 'MOGLIE',
    NIPOTE = 'NIPOTE',
    NONNO = 'NONNO',
    NONNA = 'NONNA',
    PADRE = 'PADRE',
    RICHIEDENTE = 'RICHIEDENTE',
    SCONOSCIUTA = 'SCONOSCIUTA',
    SORELLA = 'SORELLA',
    TUTORE = 'TUTORE',
    ZIO = 'ZIO',
    ZIA = 'ZIA'
};



